import { api } from '../../../services/api';

export interface BankImportSessionDTO {
  id: string;
  companyId: string;
  bankAccountId: string;
  fileName: string;
  fileMimeType: string;
  sourceFormat: 'OFX' | 'OPEN_FINANCE';
  status: 'PENDING' | 'PROCESSING' | 'EXTRACTED' | 'COMPLETED' | 'FAILED';
  periodStart: string | null;
  periodEnd: string | null;
  errorMessage: string | null;
  createdAt: string;
  bankAccount?: { id: string; name: string; bankName: string };
}

export interface BankImportTransactionDTO {
  id: string;
  sessionId: string;
  transactionDate: string;
  amount: number;
  type: 'INCOME' | 'EXPENSE';
  description: string;
  suggestedCategoryId: string | null;
  /** Rateio: empresa que realmente incorreu na despesa desta linha. */
  beneficiaryCompanyId: string | null;
  // RULE: sugerida por regra; MANUAL: classificada pelo Marcus ou pelo lote da Nami.
  categorySource: 'HISTORY' | 'NONE' | 'RULE' | 'MANUAL';
  duplicateOfTransactionId: string | null;
  status: 'PENDING' | 'REJECTED' | 'IMPORTED' | 'DUPLICATE_SKIPPED';
  financialTransactionId: string | null;
  suggestedCategory?: {
    id: string;
    name: string;
    type: 'INCOME' | 'EXPENSE';
    color: string;
  } | null;
  duplicateOfTransaction?: {
    id: string;
    transactionDate: string;
    amount: string;
    description: string;
  } | null;
}

export interface ApproveResult {
  approved: number;
  skipped: number;
  imported: Array<{ transactionId: string; financialTransactionId: string }>;
  errors: Array<{
    transactionId: string;
    code: 'NOT_FOUND' | 'NOT_PENDING' | 'DUPLICATE_BLOCKED' | 'NO_CATEGORY';
  }>;
}

export const bankImportsService = {
  list: (params: {
    companyId: string;
    bankAccountId?: string;
    status?: string;
    page?: number;
    limit?: number;
  }) => api.get('/financial/bank-imports', { params }).then((r) => r.data),

  getOne: (id: string) =>
    api
      .get<{
        success: boolean;
        data: { session: BankImportSessionDTO; transactions: BankImportTransactionDTO[] };
      }>(`/financial/bank-imports/${id}`)
      .then((r) => r.data),

  upload: (bankAccountId: string, file: File) => {
    const fd = new FormData();
    fd.append('bankAccountId', bankAccountId);
    fd.append('file', file);
    return api
      .post('/financial/bank-imports', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },

  patchTransaction: (
    sessionId: string,
    txId: string,
    patch: Partial<{
      suggestedCategoryId: string | null;
      beneficiaryCompanyId: string | null;
      type: 'INCOME' | 'EXPENSE';
      description: string;
      status: 'REJECTED';
    }>
  ) =>
    api
      .patch(`/financial/bank-imports/${sessionId}/transactions/${txId}`, patch)
      .then((r) => r.data),

  approve: (sessionId: string, body: { transactionIds: string[]; includeDuplicates: boolean }) =>
    api.post(`/financial/bank-imports/${sessionId}/approve`, body).then((r) => r.data),

  rejectAll: (sessionId: string) =>
    api.post(`/financial/bank-imports/${sessionId}/reject-all`).then((r) => r.data),
};
